import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

/**
 * This method is used to remove duplicating front-end logic to figure out if we are currently working
 * with an org-default or a job-level override.
 *
 * @param automation - This is either the org-default automation to create an override off of OR
 * the existing job-level override that will be updated with the input params
 *
 * @param params - The create or update overrides that will replace current automation values
 */
export const createOrUpdateJobOverride = (
  automation: ApplicantAutomation,
  params: ApplicantAutomationUpdate | ApplicantAutomationJobOverrideCreate,
) => {
  const context = automation.jobId
    ? {
        updateExistingId: automation.applicantTriggeredCommunicationId,
      }
    : {
        createFromOrgDefaultId: automation.applicantTriggeredCommunicationId,
      };

  return createGenericDispatcher({
    name: 'CREATE_APPLICANT_AUTOMATION',
    loadFunction: () =>
      Api.post('/applicant-automations/job-override', {
        body: JSON.stringify({
          ...context,
          ...params,
        }),
      }),
    args: { params },
  });
};
